import React, { useState } from 'react';
import styled from 'styled-components';
import { Typography } from '@ntuctech/devex-tangram';
import Chip from '@ntuctech/devex-tangram/Chip';
import Grid from '@ntuctech/devex-tangram/Grid';
import Input from '@ntuctech/devex-tangram/Input';
import DropDown from '../../DropDown';
import Slider, { CarouselItem } from './Slider';
import { SCREEN_SIZE } from '../../../lib/mediaQuery';
import { findCategory } from '../../../lib/utils';
import AddMessage from './AddMessage';

const WhiteBox = styled.div`
  background-color: #fff;
  border-radius: 0.5rem;
  border: 1px solid #eaeaea;
  padding: 2rem;
  margin-bottom: 1rem;

  .no-space {
    padding: 0 !important;
    margin: 0 !important;
  }
  .pos-relative {
    position: relative;
  }
  ${SCREEN_SIZE.Only.Tablet} {
    padding: 1.5rem !important;
  }
  ${SCREEN_SIZE.Below.MobileL} {
    padding: 1rem;
    border-radius: 0;
    border: 0;
  }
`;

const BoxTitle = styled.h5`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #333333;
  margin: 0;
`;

const SliderBox = styled.div`
  margin-top: 1.5rem;
  position: relative;
  > div > div > div > div > div:nth-child(1) h1 {
    margin-left: 0;
  }
  > div > div > div > div > div:nth-last-child(1) h1 {
    margin-right: 0;
  }
  > div > div {
    padding: 0px 0px;
  }
  button:nth-child(3) {
    right: 15px;
  }
  button:nth-child(2) {
    right: 15px;
  }
  button:nth-child(1) {
    left: 15px;
  }
  button {
    margin-top: 0;
    top: calc(50% - 18px);
    text-align: center;
    background: #fff;
    opacity: 0.6;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    color: #fff;
    position: absolute;
    font-weight: bold;
    border: 0;
  }
  button:before {
    left: 12px;
    top: 12px;
  }
  button:nth-child(3):before {
    left: 10px;
  }
  img {
    object-fit: cover;
    display: block;
    border-radius: 0px;
    position: relative;
  }
  .activeItem {
    & > div {
      border: 3px solid rgb(20 84 184);
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0px;
      top: 0px;
      z-index: 1;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0px 0px 0px 3px #fff inset;
    }
  }
  @media screen and (max-width: 768px) {
    button {
      display: none;
    }
  }
  @media screen and (max-width: 1023px) and (min-width: 768px) {
    button {
      color: #fff;
    }
    button:before {
      border-top: solid 2px #fff;
      border-right: solid 2px #fff;
    }
  }
  @media screen and (min-width: 1024px) {
    button {
      background: #fff;
      opacity: 1;
      button:before {
        border-top: solid 2px #000 !important;
        border-right: solid 2px #000 !important;
      }
      color: #000;
    }
  }
`;

const HoverImage = styled.div`
  border-radius: 8px;
  overflow: hidden;
`;

const ImgWrapper = styled.div`
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  &:hover {
    & > div {
      border: 2px solid rgb(20 84 184);
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0px;
      top: 0px;
      z-index: 1;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0px 0px 0px 3px #fff inset;
    }
  }
`;

const ChipSection = styled.div`
  display: inline-block;
  margin: 1.5rem 0;
  > div {
    margin-right: 0.25rem;
    margin-bottom: 0;
    padding: 0.5rem 0.75rem;
  }
`;

export const VoucherValue = styled.div`
  > div:hover input {
    border-color: #666666 !important;
  }
  > div:hover label {
    color: inherit !important;
  }
  > div input:hover {
    border-color: #1454b8 !important;
  }
  > div {
    margin-bottom: 0;
    width: 100%;
  }
  > div div {
    width: 100%;
  }
  input {
    max-width: 328px;
    margin: 0 auto 0 0;
    :-webkit-autofill,
    :-webkit-autofill:hover,
    :-webkit-autofill:focus,
    :-webkit-autofill:active {
      box-shadow: 0 0 0 30px white inset !important;
    }
  }
  input[type='date'] {
    width: 167px;
  }
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
  @media screen and (max-width: 768px) {
    input {
      max-width: 100%;
    }
  }
`;

const chipdata = [
  {
    value: 5,
    label: '$5',
  },
  {
    value: 10,
    label: '$10',
  },
  {
    value: 20,
    label: '$20',
  },
  {
    value: 50,
    label: '$50',
  },
  {
    value: 100,
    label: '$100',
  },
];

const VoucherCategories = (props) => {
  const {
    voucherData,
    setVoucherData,
    manuallyMsg,
    setManuallymsg,
    selectOptions,
    voucherMetaData,
    filteredImg,
    setCategory,
    category,
    isB2bEnabled,
    track,
    counterInputRef,
  } = props;
  const [isLastIndex, setIsLastIndex] = useState(false);
  const [isError, setError] = useState(false);

  const exceptThisSymbols = ['e', 'E', '+', '-', '.'];

  const helperText = () => {
    return voucherData.amount > 1000
      ? 'Enter a whole amount between $1 and $1,000, without cents'
      : '';
  };

  /* eslint-disable no-useless-escape */

  const onPaste = (e) => {
    const paste = e.clipboardData.getData('text/plain');
    if (paste && paste.match(/[-\.]/)) {
      e.preventDefault();
    }
  };

  const allTheRefs = {};
  /* eslint-disable no-unused-expressions */
  return (
    <>
      <WhiteBox data-testid="white-box" isB2bEnabled={isB2bEnabled}>
        <Grid container className="no-space">
          <Grid item xs={12} className="no-space pos-relative">
            <BoxTitle>Pick a design</BoxTitle>
            <DropDown
              name="VoucherCategory"
              data-testid="voucher-category"
              value={voucherData.metadata.catergory}
              options={selectOptions}
              track={track}
              overlay
              onClick={(value) => {
                if (manuallyMsg === false) {
                  setVoucherData({
                    ...voucherData,
                    metadata: {
                      ...voucherData.metadata,
                      catergory: value,
                      message:
                        voucherMetaData?.find((item) => item.catergory === value)?.message ||
                        voucherMetaData?.[0]?.message,
                    },
                  });
                }
                setVoucherData({
                  ...voucherData,
                  metadata: {
                    ...voucherData.metadata,
                    catergory: value,
                    message:
                      voucherMetaData?.find((item) => item.catergory === value)?.message ||
                      voucherMetaData?.[0]?.message,
                  },
                });
                setCategory(value);
                if (voucherData.metadata.message === '') {
                  setManuallymsg(false);
                }
              }}
            />
          </Grid>
          <Grid item xs={12} className="no-space">
            <div>
              <SliderBox>
                <Slider
                  category={category}
                  voucherMetaData={voucherMetaData}
                  filteredImg={filteredImg}
                  isLastIndex={isLastIndex}
                  voucherData={voucherData}
                  track={track}
                >
                  {filteredImg
                    ?.filter((filterImg) => filterImg?.type !== 'banner')
                    .map((item, ind, { length }) => {
                      const isSelected =
                        voucherData.metadata.image !== undefined &&
                        item.png === voucherData.metadata.image;
                      return (
                        <CarouselItem key={`${category}-${item.png}`}>
                          <ImgWrapper className={isSelected ? 'activeItem' : ''}>
                            <HoverImage
                              ref={(ref) => {
                                allTheRefs[ind] = ref;
                              }}
                              data-testid="voucher-theme"
                              data-selected={isSelected}
                              onClick={() => {
                                setIsLastIndex(ind + 1 === length);
                                allTheRefs[ind]?.scrollIntoView({
                                  behavior: 'smooth',
                                  block: 'center',
                                });
                                if (manuallyMsg === false) {
                                  setVoucherData({
                                    ...voucherData,
                                    metadata: {
                                      ...voucherData.metadata,
                                      image: item.png,
                                      name: findCategory(item.png, voucherMetaData),
                                      message: item.message,
                                    },
                                  });
                                }
                                setVoucherData({
                                  ...voucherData,
                                  metadata: {
                                    ...voucherData.metadata,
                                    image: item.png,
                                    name: findCategory(item.png, voucherMetaData),
                                    message: item.message,
                                  },
                                });
                              }}
                            />
                            <img
                              name="VoucherTheme"
                              alt={item.catergory}
                              src={item.png}
                              aria-hidden="true"
                            />
                          </ImgWrapper>
                        </CarouselItem>
                      );
                    })}
                </Slider>
              </SliderBox>
            </div>
          </Grid>
        </Grid>
      </WhiteBox>
      {!isB2bEnabled && (
        <>
          <AddMessage
            voucherData={voucherData}
            setVoucherData={setVoucherData}
            setManuallymsg={setManuallymsg}
            counterInputRef={counterInputRef}
            isB2bEnabled={isB2bEnabled}
          />{' '}
          <WhiteBox>
            <Grid container className="no-space">
              <Grid item xs={12} className="no-space">
                <BoxTitle>Pick or enter voucher amount</BoxTitle>
                <div>
                  <Typography variant="bodyM">Min. amount $1. Max. amount $1,000.</Typography>
                </div>
                {chipdata.map((item, index) => (
                  <ChipSection key={`${item.label}-${item.value}`}>
                    <Chip
                      data-testid={`voucher-value-${index}`}
                      name="VoucherValue"
                      label={item.label}
                      selected={voucherData.amount / voucherData.quantity === item.value}
                      onClick={() =>
                        setVoucherData({
                          ...voucherData,
                          amount: item.value * voucherData.quantity,
                        })
                      }
                      value={voucherData.amount / voucherData.quantity}
                    />
                  </ChipSection>
                ))}

                <VoucherValue>
                  <Input
                    data-testid="voucher-value"
                    label="Custom amount"
                    name="VoucherValue"
                    helpText={helperText()}
                    type="number"
                    required
                    placeholder="$0"
                    min={0}
                    value={voucherData.amount !== '' && voucherData.amount / voucherData.quantity}
                    error={isError}
                    onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                    onChange={(event) => {
                      event.target.value !== '' &&
                      (event.target.value > 1000 || event.target.value === 0)
                        ? setError(true)
                        : setError(false);
                      const value = event.target.value * voucherData.quantity;
                      setVoucherData({
                        ...voucherData,
                        amount: value === 0 ? '' : value,
                      });
                    }}
                    onPaste={onPaste}
                  />
                </VoucherValue>
              </Grid>
            </Grid>
          </WhiteBox>
        </>
      )}
    </>
  );
};
export default VoucherCategories;
